import React, { useEffect } from 'react';
import { MapPin } from 'lucide-react';
import './Contatos.css';

const WHATSAPP_NUMERO = '5562998485292';
const WHATSAPP_EXIBICAO = '62 99848-5292';
const WHATSAPP_MENSAGEM = 'Olá, Margareth! Vim pela sua página de contatos e gostaria de ver o catálogo.';
const INSTAGRAM_USUARIO = 'espaco_magg';

const FONTES_URL =
  'https://fonts.googleapis.com/css2?family=Fraunces:opsz,wght@9..144,500;9..144,600&family=Lexend:wght@300;400;600&display=swap';

const IconeWhatsApp = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path
      fill="currentColor"
      d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"
    />
  </svg>
);

const IconeInstagram = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round">
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4.2" />
    <circle cx="17.4" cy="6.6" r="0.9" fill="currentColor" stroke="none" />
  </svg>
);

const LINKS = [
  {
    id: 'whatsapp',
    href: `https://wa.me/${WHATSAPP_NUMERO}?text=${encodeURIComponent(WHATSAPP_MENSAGEM)}`,
    icone: <IconeWhatsApp />,
    legenda: (
      <>
        Solicite nosso <strong>catálogo</strong>
      </>
    ),
    titulo: WHATSAPP_EXIBICAO,
    rotulo: `Chamar no WhatsApp: ${WHATSAPP_EXIBICAO}`,
  },
  {
    id: 'instagram',
    href: `https://www.instagram.com/${INSTAGRAM_USUARIO}/`,
    icone: <IconeInstagram />,
    legenda: (
      <>
        Siga no <strong>Instagram</strong>
      </>
    ),
    titulo: `@${INSTAGRAM_USUARIO}`,
    rotulo: `Abrir o Instagram @${INSTAGRAM_USUARIO}`,
  },
];

const LINHAS = ['Perfumes Nacionais & Importados', 'O Boticário', 'Natura', 'Perfumes Árabes'];

export default function Contatos() {
  useEffect(() => {
    const tituloAnterior = document.title;
    document.title = 'Contatos | Margareth Bernardo';

    let link = document.getElementById('mb-contatos-fontes');
    if (!link) {
      link = document.createElement('link');
      link.id = 'mb-contatos-fontes';
      link.rel = 'stylesheet';
      link.href = FONTES_URL;
      document.head.appendChild(link);
    }

    return () => {
      document.title = tituloAnterior;
    };
  }, []);

  return (
    <div
      className="mb-contatos"
      data-testid="pagina-contatos"
      style={{ '--mb-logo': "url('/logo-margareth-black.png')" }}
    >
      <div className="mb-contatos__grao" aria-hidden="true" />
      <div className="mb-contatos__arco" aria-hidden="true" />

      <img className="mb-contatos__frasco mb-contatos__frasco--212" src="/contatos/frasco-212.webp" alt="" aria-hidden="true" />
      <img className="mb-contatos__frasco mb-contatos__frasco--chanel" src="/contatos/frasco-chanel.webp" alt="" aria-hidden="true" />
      <img className="mb-contatos__frasco mb-contatos__frasco--egeo" src="/contatos/frasco-egeo.webp" alt="" aria-hidden="true" />

      <main className="mb-contatos__conteudo">
        <h1 className="mb-contatos__logo">
          <span className="sr-only">Margareth Bernardo</span>
        </h1>

        <p className="mb-contatos__chamada">Os perfumes certos para as</p>
        <p className="mb-contatos__destaque">
          Sedutoras, elegantes <span>&amp;</span> marcantes
        </p>

        <nav className="mb-contatos__links" aria-label="Contatos">
          {LINKS.map((l) => (
            <a
              key={l.id}
              className="mb-contatos__botao"
              href={l.href}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={l.rotulo}
              data-testid={`link-${l.id}`}
            >
              <span className="mb-contatos__icone">{l.icone}</span>
              <span className="mb-contatos__texto">
                <span className="mb-contatos__legenda">{l.legenda}</span>
                <span className="mb-contatos__titulo">{l.titulo}</span>
              </span>
            </a>
          ))}
        </nav>

        <section className="mb-contatos__assinatura">
          <img className="mb-contatos__monograma" src="/contatos/monograma-mb.png" alt="MB Consultora" />
          <ul>
            {LINHAS.map((t) => (
              <li key={t}>{t}</li>
            ))}
          </ul>
          <p className="mb-contatos__entregas">
            <MapPin aria-hidden="true" />
            <span>
              <small>Entregas:</small>
              Goiânia e Região
            </span>
          </p>
        </section>
      </main>
    </div>
  );
}
